<template>
    <LayoutBase>
        <div class="container app-position">
            <div class="">
                <header id="header">
                    <div class="">
                        <h1 class="h1">Files</h1>
                    </div>
                    <div class="text-right">
                        <file-upload name="featured-image-upload" v-model="file" label="Upload a new file"></file-upload>
                    </div>
                </header>

                <div class="grid">
                    <div class="col-9">
                        <div class="panel row">
                            <ListFiles></ListFiles>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';
    import ListFiles from '../../list/ListFiles';

    export default {
        name: "Files",
        components: {
            LayoutBase,
            ListFiles
        },
        data () {
            return {
                file: null,
                files: [],
            }
        },
        mounted() {
            this.getFiles();
        },
        methods: {
            getFiles() {
                axios.get('/api/media/list').then((response) => {
                    this.files = response.data.entries;
                    //console.log(this.posts.slice(0, 1));
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>

<style lang="scss">
    .files{
    }
</style>